(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/de-at", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/de-at"] = factory();
	else
		root["i18n/de-at"] = factory();
})(window, function() {
return 